// @core/api/endpoints/apikey/get_api_key_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  APIKeyPolicyResponse,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Get API key policy
 * Returns an API key policy by ID.
 */
export async function GetAPIKeyPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<APIKeyPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/api-key-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.get<APIKeyPolicyResponse>(requestPath, { ...requestOptions });
}
